module.exports = __webpack_public_path__ + "static/media/pin_gasolina.7de81a96.png";